import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Dropdown from 'react-bootstrap/Dropdown';
import { useWindowSize } from "../../../hooks/useWindowSize";
import DropdownButton from 'react-bootstrap/DropdownButton';
import Form from 'react-bootstrap/Form';
import DatePicker from "react-datepicker";
import Modal from 'react-bootstrap/Modal'
// import { DatePickerField } from "../../../shared/_helpers/datepicker";
import { NavLink, Link } from "react-router-dom"

import { AlertMsg } from "../../../shared/components/alert-msg"

import "react-datepicker/dist/react-datepicker.css";
import InputGroup from 'react-bootstrap/InputGroup';
import { TableComponent } from "../../../shared/components/table"
import { InAppTemplate } from "../../../shared/templates/inapp";
import { storeActions } from "../../../redux/actions/in-app"
import SearchIco from "../../../assets/icons/search.svg"
import PP from "../../../assets/pp.svg"
import Caret1 from "../../../assets/icons/left-caret.svg"
import Caret2 from "../../../assets/icons/right-caret.svg"
import Chat from "../../../assets/chat.svg"
import CallNow from "../../../assets/call.svg"
import { LoadingItem } from "../../../shared/components/loading"
import { getDateFromISO } from "../../../shared/utils"

import ReactPaginate from 'react-paginate';

import "../index.scss"

const getStoreOrders = async ({ pageProps, payload }: any) => {

    await pageProps.getStoreOrders(payload);
}

const InAppContent = ({ pageProps }: any) => {
    const [startDate, onStartChange] = useState<any>();
    const [endDate, onEndChange] = useState<any>();
    const [showDeliveryModal, setShowDeliveryModal] = useState(false);
    const [deliveryInfo, setDeliveryInfo] = useState<any>();
    const screenResolution: any = useWindowSize();

    const [currentPage, setCurrentPage] = useState(1);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    // let page = 1,
    //     pageSize = 10;

    useEffect(() => {
        let payload = `Page=${pageNumber}&Size=${pageSize}`;
        getStoreOrders({
            pageProps,
            payload
        })


    }, [])

    useEffect(() => {
        let payload = `Page=${pageNumber}&Size=${pageSize}`;
        getStoreOrders({
            pageProps,
            payload
        })

    }, [pageNumber, pageSize])


    const ReportTable = ({ reportData }: any) => {
        let orderList: any[] = reportData?.results;
        if (orderList.length >= 1) {
            orderList = orderList.filter(eachItem => eachItem.status === "Successful")
            return (
                <>
                    <thead>
                        <tr>
                            {/* <th>
                                <span>S/N</span>
                            </th> */}
                            <th>
                                <span>Order ID</span>
                            </th>
                            <th> <span>Order Date</span></th>
                            <th>Status</th>
                            <th>Subtotal</th>

                            <th> <span>Order Information</span></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            orderList.map((eachItem: any, index: any) => {
                                return (
                                    <tr key={index}>
                                        {/* <td>
                                            {index + 1}
                                        </td> */}
                                        <td>
                                            #{eachItem.number}
                                        </td>
                                        <td>
                                            <div className="date-item">{getDateFromISO({ date: eachItem.createdDate }) || "N/A"}</div>
                                        </td>
                                        <td>
                                            {eachItem.status === "Intent" && <span className="order-status waiting">Pending</span>}
                                            {eachItem.status === "Failed" && <span className="order-status failed">Failed</span>}
                                            {eachItem.status === "Successful" && <span className="order-status done">Successful</span>}
                                            {/* {eachItem.status === "Intent" && "Pending"}
                                            {eachItem.status === "Failed" && "Failed"}
                                            {eachItem.status === "Successful" && "Completed"} */}
                                        </td>
                                        <td>
                                            ${eachItem.subtotal}
                                        </td>
                                        <td>
                                            <div className="view-order">
                                                <Link to={`/app/my-orders/${eachItem.id}`}>See details</Link>
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                        {/* {
                        productsList.map((eachItem, index) => {
                            return (
                                <tr key={index}>
                                    <td>
                                        <div className="product-info">
                                            <img src={eachItem.productImg} alt="" />
                                            <div className="prod-name">
                                                {eachItem.productName}
                                                <span>View Details</span>
                                            </div>
                                        </div>
                                    </td>

                                    <td><span className="unit-price">${eachItem.unitPrice}</span> </td>
                                    <td><span className="unit-price">{eachItem.instock}</span> </td>
                                    <td><span className="unit-price">$2.00</span> </td>
                                    <td><span className="unit-total">$31.19</span> </td>
                                    <td><span className="cate">{eachItem.category}</span> </td>
                                    <td><div className="date-item">{eachItem.dateCreated}</div> </td>
                                    <td><div className="date-item">Paid</div> </td>

                                    <td><div className="date-item">{eachItem.dateCreated}</div> </td>
                                    <td>
                                        <button onClick={() => { setShowDeliveryModal(true); setDeliveryInfo(eachItem) }}>Delivery Address</button>
                                    </td>
                                </tr>
                            )
                        })
                    } */}

                    </tbody>
                </>
            )
        } else {
            <div className="order-wrap">

                <div className="order-items-list">
                    <div className="all_products">
                        Order details unavailable
                    </div>
                </div>
            </div>
        }

        return <></>

    }

    const MobileDataGrid = ({ reportData }: any) => {

        let orderList: any[] = reportData?.results;
        if (orderList.length >= 1) {
            orderList = orderList.filter(eachItem => eachItem.status === "Successful")
            return (
                <div className="mobile-data-grid">
                    {(orderList.length >= 1) &&
                        <>
                            {orderList.map((eachItem: any, index: any) => {
                                return (
                                    <div className="each_data_item" key={index}>
                                        <div className="top-tiny-txt">{getDateFromISO({ date: eachItem.createdDate }) || "N/A"} </div>
                                        <div className="main-txt-head">
                                            <div className="head-txt">
                                                <span>Order number</span>
                                                {eachItem?.number}
                                            </div>
                                            <div className="other-head-txt done">
                                                {eachItem.status === "Intent" && "Pending"}
                                                {eachItem.status === "Failed" && "Failed"}
                                                {eachItem.status === "Successful" && "Completed"}
                                            </div>
                                        </div>
                                        {/* <div className="availability">
                                            <div className="title-txt">Availability </div>
                                            
                                        </div> */}
                                        {/* <div className="cat-items-list">
                                            <div className="title-txt">Category </div>
                                      
                                        </div> */}
                                        <div className="cta-btns">
                                            <Link className="cta-link-txt" to={`/app/my-orders/${eachItem.id}`}>View Order</Link>
                                        </div>
                                    </div>
                                )
                            })}

                        </>

                    }

                </div >
            )
        } else {
            <div className="order-wrap">

                <div className="order-items-list">
                    <div className="all_products">
                        Order details unavailable
                    </div>
                </div>
            </div>
        }
        return <></>
    }

    const handlePageClick = (event: any) => {

        setPageNumber(event?.selected + 1)

    }

    return (
        <div className="inapp-content">
            <Modal className="address_modal_wrap" show={showDeliveryModal} onHide={() => setShowDeliveryModal(false)}>
                <Modal.Header closeButton>
                    {/* <div className="reason_heading">Reason for return </div> */}
                </Modal.Header>
                <Modal.Body>
                    <div className="customer-info">
                        <div className="customer-avatar">
                            <img src={PP} alt="" />
                        </div>
                        <div className="customer-details">
                            <div className="customer-name">{deliveryInfo?.customerName}</div>
                            <div className="customer-email">{deliveryInfo?.customerEmail}</div>
                            <div className="inbox-cta">
                                <button type="button">
                                    <img src={Chat} alt="" />
                                    <span>Message Customer</span>
                                </button>
                            </div>
                            <div className="call-cta">
                                <button type="button">
                                    <img src={CallNow} alt="" /> <span>{deliveryInfo?.customerPhone}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="customer-address">
                        <h3>Delivery Address</h3>
                        {deliveryInfo?.customerAddress}
                    </div>

                </Modal.Body>
            </Modal>
            <div className="page-content lists-wrap cards with-heading order-wrap">
                <div className="orders-header">
                    <h3>Orders</h3>
                    <div className="orders-txt">You can manage all of your customer orders in one place; you can view a list of all your orders, check their current status, and update them as needed.</div>
                </div>
                <div className="list-contanier">

                    <div className="list-content-wrap  products-list">
                        {pageProps.getStoreOrdersRequest.request_status === "GET_VENDOR_ORDERS_PENDING" &&
                            <LoadingItem />
                        }
                        {pageProps.getStoreOrdersRequest.request_status === "GET_VENDOR_ORDERS_SUCCESS" &&
                            <div>

                                <div className="all-items">

                                    <div className="sub-headings">
                                        <div className="each-menu">
                                            <NavLink end className={({ isActive }) => (isActive ? 'active-nav' : '')} to="/app/my-orders">
                                                Ordered Products
                                                <span className="underline"></span>
                                            </NavLink>
                                        </div>
                                        <div className="each-menu">
                                            <NavLink end className={({ isActive }) => (isActive ? 'active-nav' : '')} to="/app/my-orders/cancelled">
                                                Cancelled Orders
                                            </NavLink>
                                        </div>
                                    </div>

                                    <div className="all-items-list">
                                        {screenResolution?.width >= 768 &&
                                            <TableComponent
                                                childComponent={<ReportTable reportData={pageProps.getStoreOrdersRequest.request_data.response} />}
                                            />
                                        }
                                        {(screenResolution?.width <= 767 && pageProps?.getStoreOrdersRequest?.request_data?.response) &&
                                            <MobileDataGrid
                                                reportData={pageProps.getStoreOrdersRequest.request_data.response}

                                            />
                                        }

                                        {(pageProps?.getStoreOrdersRequest?.request_data?.response?.totalNumberOfRecords > pageSize) &&
                                            <ReactPaginate
                                                breakLabel="..."
                                                nextLabel=">"
                                                // initialPage={1}
                                                onPageChange={handlePageClick}
                                                pageRangeDisplayed={4}
                                                forcePage={pageNumber - 1}
                                                // onClick={handleItemsClick}
                                                className="pagination_items"
                                                pageClassName="page_num"
                                                pageLinkClassName="page_link"
                                                activeClassName="active_page_link"
                                                previousClassName="previous_page_link"
                                                nextClassName="next_page_link"
                                                pageCount={pageProps?.getStoreOrdersRequest?.request_data?.response?.pageNumber}
                                                previousLabel="<"
                                                // @ts-ignore
                                                renderOnZeroPageCount={null}
                                            />
                                        }

                                        {/* <div className="pagination-wrap to-right">
                                            <div className="prev-page each-page">
                                                <img src={Caret1} alt="" />
                                            </div>
                                            <div className="prev-page each-page active">1</div>
                                            <div className=" each-page">2</div>
                                            <div className=" each-page">3</div>
                                            <div className=" each-page">4</div>
                                            <div className=" each-page">5</div>
                                            <div className="next-page each-page">
                                                <img src={Caret2} alt="" />
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        }
                        {pageProps.getStoreOrdersRequest.request_status === "GET_VENDOR_ORDERS_FAILURE" &&
                            <AlertMsg type="error" message={pageProps.getStoreOrdersRequest?.request_data.error} />
                        }

                    </div>
                </div>
            </div>
        </div>
    )

}
const OrderList = (pageProps: any) => {
    return (
        <InAppTemplate pageHeadingTitle="My Orders" childComponent={<InAppContent pageProps={pageProps} />} />
    )
}

const mapDispatchToProps = {
    getStoreOrders: storeActions.GetStoreOrders,
};

const mapStateToProps = (state: any) => ({
    // return {
    getStoreOrdersRequest: state.allProductReducers.getStoreOrderReducer,

    // };
})
export default connect(mapStateToProps, mapDispatchToProps)(OrderList);